var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngryFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9344 2.7002C0.4625 2.7002 0 24.5314 0 28.8533C0 33.1752 8.925 36.6752 19.9344 36.6752C30.9469 36.6752 39.8688 33.1721 39.8688 28.8533C39.8688 24.5314 39.4094 2.7002 19.9344 2.7002Z",
    fill: "#FCC21B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0562 27.9688C16.1905 23.6563 23.678 23.6563 27.8124 27.9688",
    stroke: "#2F2F2F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4782 15.2723C30.4425 15.1677 30.3851 15.0718 30.3097 14.991C30.2343 14.9102 30.1426 14.8463 30.0407 14.8036C29.8344 14.7161 29.6032 14.7192 29.4 14.813L24.2407 17.1723C24.2407 17.1723 23.9032 17.3317 23.5563 17.3255C22.8469 17.3161 22.7719 16.9067 22.5875 16.5942C22.5032 16.4442 22.2938 16.2973 22.0969 16.3786C21.7625 16.5192 21.7844 17.2505 21.8094 17.4348C21.8875 17.9786 22.0438 18.4005 22.1938 18.7036C22.3782 19.0723 22.7907 19.5848 22.9313 19.7192C23.6969 20.4817 25.0157 20.9598 26.3563 20.8817C26.9063 20.8536 27.4375 20.7317 27.9375 20.5286C30.7438 19.3755 30.9938 16.7505 30.4782 15.2723ZM9.45629 15.2723C9.4919 15.1677 9.54931 15.0718 9.62473 14.991C9.70015 14.9102 9.79185 14.8463 9.89379 14.8036C10.1 14.7161 10.3313 14.7192 10.5375 14.813L15.6969 17.1723C15.6969 17.1723 16.0313 17.3317 16.3782 17.3255C17.0875 17.3161 17.1657 16.9067 17.3438 16.5942C17.4313 16.4442 17.6375 16.2973 17.8344 16.3786C18.1688 16.5192 18.1469 17.2505 18.1219 17.4348C18.0469 17.9786 17.8907 18.4005 17.7375 18.7036C17.5532 19.0723 17.1407 19.5848 17 19.7192C16.2313 20.4817 14.9157 20.9598 13.5719 20.8817C13.0188 20.8536 12.4875 20.7317 11.9907 20.5286C9.19066 19.3755 8.94066 16.7505 9.45629 15.2723Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryFace);
export default __webpack_public_path__ + "static/media/angry-face.6de494480105e7582a67ad6077b04c99.svg";
export { ForwardRef as ReactComponent };